import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaInstagram, FaFacebookF, FaYoutube, FaLinkedinIn } from 'react-icons/fa';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const [isSent, setIsSent] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSent(true);
    setTimeout(() => setIsSent(false), 5000);
  };

  return (
    <section className="contact">
      <div className="contact-container">
        
        <motion.div 
          className="contact-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
        >
          <h4 className="contact-subtitle">CONTACT US</h4>
          <h2 className="contact-title">Let's Connect</h2>
          <p className="contact-desc">
            Have questions or need guidance? We're here to help you start your yoga journey.
          </p>
          <div className="contact-divider"></div>
        </motion.div>

        <div className="contact-grid">
          
          {/* Left Side: Contact Details */}
          <motion.div 
            className="contact-details"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6 }}
          >
            <div className="info-card">
              <div className="info-icon">📍</div>
              <div>
                <h4 className="info-title">Studio Address</h4>
                <p className="info-text">No. 24, MG Road,<br/>Bengaluru,<br/>Karnataka - 560001</p>
              </div>
            </div>

            <div className="info-card">
              <div className="info-icon">📞</div>
              <div>
                <h4 className="info-title">Phone</h4>
                <p className="info-text">+91 98765 43210</p>
              </div>
            </div>

            <div className="info-card">
              <div className="info-icon">📧</div>
              <div>
                <h4 className="info-title">Email</h4>
                <p className="info-text">info@shaktiyoga.com</p>
              </div>
            </div>

            <div className="info-card">
              <div className="info-icon">🕒</div>
              <div>
                <h4 className="info-title">Opening Hours</h4>
                <p className="info-text">
                  <strong>Monday - Friday</strong><br/>6:00 AM - 8:00 PM<br/><br/>
                  <strong>Saturday</strong><br/>7:00 AM - 6:00 PM<br/><br/>
                  <strong>Sunday</strong><br/>Special Workshops
                </p>
              </div>
            </div>
            
            <div className="social-links">
              <a href="#instagram" className="social-icon"><FaInstagram /></a>
              <a href="#facebook" className="social-icon"><FaFacebookF /></a>
              <a href="#youtube" className="social-icon"><FaYoutube /></a>
              <a href="#linkedin" className="social-icon"><FaLinkedinIn /></a>
            </div>
          </motion.div>

          {/* Right Side: Contact Form */}
          <motion.div 
            className="contact-form-wrapper"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <AnimatePresence mode="wait">
              {isSent ? (
                <motion.div 
                  className="contact-success"
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.9 }}
                >
                  <div className="check-circle">✓</div>
                  <h3>Message Sent!</h3>
                  <p>We'll get back to you shortly.</p>
                </motion.div>
              ) : (
                <form className="contact-form" onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label>Name</label>
                    <input type="text" name="name" placeholder="Enter your name" required onChange={handleChange} />
                  </div>
                  
                  <div className="form-row">
                    <div className="form-group">
                      <label>Email</label>
                      <input type="email" name="email" placeholder="Enter your email" required onChange={handleChange} />
                    </div>
                    <div className="form-group">
                      <label>Phone</label>
                      <input type="tel" name="phone" placeholder="Enter your phone number" required onChange={handleChange} />
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Subject</label>
                    <div className="select-wrapper">
                      <select name="subject" required onChange={handleChange} defaultValue="">
                        <option value="" disabled>Select Subject</option>
                        <option value="General Inquiry">General Inquiry</option>
                        <option value="Book a Class">Book a Class</option>
                        <option value="Membership">Membership</option>
                        <option value="Private Session">Private Session</option>
                        <option value="Feedback">Feedback</option>
                      </select>
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Message</label>
                    <textarea name="message" rows="5" placeholder="How can we help you?" required onChange={handleChange}></textarea>
                  </div>

                  <button type="submit" className="btn-send">Send Message</button>
                </form>
              )}
            </AnimatePresence>
          </motion.div>

        </div>
      </div>
      
      {/* Google Map */}
      <div className="map-container">
         <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15551.494794270119!2d77.59336152011039!3d12.979929849103822!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae167e411b9ddf%3A0x64b855ba0c648dc!2sMG%20Road%2C%20Bengaluru%2C%20Karnataka!5e0!3m2!1sen!2sin!4v1700123456789!5m2!1sen!2sin" 
            width="100%" 
            height="450" 
            style={{border: 0}} 
            allowFullScreen="" 
            loading="lazy" 
            referrerPolicy="no-referrer-when-downgrade"
            title="Yoga Studio Location">
         </iframe>
      </div>
    </section>
  );
};

export default Contact;
